var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "enter-animate animate__fadeInUp",
      class: _vm.$style["m-intro"]
    },
    [
      _c(
        "div",
        { staticClass: "m-container", staticStyle: { position: "relative" } },
        [
          _c("div", { class: _vm.$style["mask"] }),
          _vm._v(" "),
          _c("div", { class: _vm.$style["container-inner"] }, [
            _c(
              "div",
              {
                staticClass: "flex justify-center items-center",
                class: _vm.$style["module-body"]
              },
              [
                _c("div", { class: _vm.$style["intro-thumb"] }, [
                  _c("div", { class: _vm.$style["intro-thumb--inner"] }, [
                    _c(
                      "div",
                      {
                        ref: "swiperDom",
                        staticClass: "swiper",
                        class: _vm.$style["swiper"]
                      },
                      [
                        _c("div", { staticClass: "video-main" }, [
                          _c("video", {
                            ref: "video",
                            attrs: {
                              preload: "auto",
                              autoplay: "",
                              loop: "",
                              muted: "",
                              playsinline: "",
                              controlsList: "nodownload",
                              src: require("@/assets/images/video/bannerVideo.mp4")
                            },
                            domProps: { muted: true }
                          })
                        ])
                      ]
                    )
                  ])
                ])
              ]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f6782c7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6782c7e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compontents/newHome/index/IntroModule.vue
// module id = B22q
// module chunks = 0